import React from "react";
import { Contact, Header, Hire, ANZSCOItem } from "./Components";
import One from "../../Assets/ANZSCO/1.png";
import Two from "../../Assets/ANZSCO/2.png";
import Three from "../../Assets/ANZSCO/3.png";
import Four from "../../Assets/ANZSCO/4.png";
import Five from "../../Assets/ANZSCO/5.png";
import Six from "../../Assets/ANZSCO/6.png";
import Seven from "../../Assets/ANZSCO/7.png";
import Eight from "../../Assets/ANZSCO/8.png";
import Nine from "../../Assets/ANZSCO/9.png";
import Ten from "../../Assets/ANZSCO/10.png";
import Eleven from "../../Assets/ANZSCO/11.png";
import Twelve from "../../Assets/ANZSCO/12.png";
import Thirteen from "../../Assets/ANZSCO/13.png";
import Fourteen from "../../Assets/ANZSCO/14.png";
import Fifteen from "../../Assets/ANZSCO/15.png";
import Sixteen from "../../Assets/ANZSCO/16.png";
import Seventeen from "../../Assets/ANZSCO/17.png";
import Eighteen from "../../Assets/ANZSCO/18.png";
import Nineteen from "../../Assets/ANZSCO/19.png";
import Twenty from "../../Assets/ANZSCO/20.png";
import TwentyOne from "../../Assets/ANZSCO/21.png";
import TwentyTwo from "../../Assets/ANZSCO/22.png";
import TwentyThree from "../../Assets/ANZSCO/23.png";
import TwentyFour from "../../Assets/ANZSCO/24.png";
import TwentyFive from "../../Assets/ANZSCO/25.png";
import TwentySix from "../../Assets/ANZSCO/26.png";
import TwentySeven from "../../Assets/ANZSCO/27.png";
import TwentyEight from "../../Assets/ANZSCO/28.png";

const CDRANZSCO = () => {
  return (
    <div className="servicesPages">
      <Header
        header="CDR ANZSCO Occupation List"
        desc="Explore the comprehensive ANZSCO occupation list tailored for engineering professionals. Selecting the most suitable ANZSCO code is vital for an accurate skills assessment and aligning with your qualifications and experience."
      />
      <div className="body">
        <div>
          <div className="header">CDR ANZSCO Code</div>
          <div className="desc">
            The Australian and New Zealand Standard Classification of Occupations (ANZSCO) Codes are used to classify all occupations in Australia and New Zealand. Selecting the
            correct ANZSCO Code is essential when assessing engineers’ migration skills.
          </div>
          <div className="desc">
            Before applying for a skilled assessment, applicants must choose the appropriate ANZSCO Code. By referencing the ANZSCO Code, you can verify your eligibility for the
            correct engineering stream assessed directly by Engineers Australia.
          </div>
          <div className="header">CDR ANZSCO Occupation List</div>
          <div className="items">
            <ANZSCOItem code="ANZSCO 233112" title="Material Engineers" img={One} />
            <ANZSCOItem code="ANZSCO 133211" title="Engineering Manager" img={Two} />
            <ANZSCOItem code="ANZSCO 233111" title="Chemical Engineers" img={Three} />
            <ANZSCOItem code="ANZSCO 233211" title="Civil Engineers" img={Four} />
            <ANZSCOItem code="ANZSCO 233212" title="Geotechnical Engineers" img={Five} />
            <ANZSCOItem code="ANZSCO 233214" title="Structural Engineers" img={Six} />
            <ANZSCOItem code="ANZSCO 233215" title="Transport Engineers" img={Seven} />
            <ANZSCOItem code="ANZSCO 233311" title="Electrical Engineers" img={Eight} />
            <ANZSCOItem code="ANZSCO 233411" title="Electronics Engineers" img={Nine} />
            <ANZSCOItem code="ANZSCO 233511" title="Industrial Engineers" img={Ten} />
            <ANZSCOItem code="ANZSCO 233512" title="Mechanical Engineers" img={Eleven} />
            <ANZSCOItem code="ANZSCO 312212" title="Civil Engineers Technician" img={Twelve} />
            <ANZSCOItem code="ANZSCO 233611" title="Mining Engineers" img={Thirteen} />
            <ANZSCOItem code="ANZSCO 233612" title="Petroleum Engineers" img={Fourteen} />
            <ANZSCOItem code="ANZSCO 233911" title="Aeronautical Engineers" img={Fifteen} />
            <ANZSCOItem code="ANZSCO 233912" title="Agricultural Engineers" img={Sixteen} />
            <ANZSCOItem code="ANZSCO 233913" title="Bio-Medical Engineers" img={Seventeen} />
            <ANZSCOItem code="ANZSCO 233914" title="Engineering Technologists" img={Eighteen} />
            <ANZSCOItem code="ANZSCO 233215" title="Environmental Engineers" img={Nineteen} />
            <ANZSCOItem code="ANZSCO 233999" title="Engineering Professional" img={Twenty} />
            <ANZSCOItem code="ANZSCO 312311" title="Computer Network and System Engineers" img={TwentyOne} />
            <ANZSCOItem code="ANZSCO 263311" title="Telecommunication Engineers" img={TwentyTwo} />
            <ANZSCOItem code="ANZSCO 263312" title="Telecommunication Network Engineers" img={TwentyThree} />
            <ANZSCOItem code="ANZSCO 263311" title="Civil Engineering Draftperson" img={TwentyFour} />
            <ANZSCOItem code="ANZSCO 233513" title="Production or Plant Engineers" img={TwentyFive} />
            <ANZSCOItem code="ANZSCO 312211" title="Electrical Engineering Draftsperson" img={TwentySix} />
            <ANZSCOItem code="ANZSCO 312312" title="Electrical Engineer Technician" img={TwentySeven} />
            <ANZSCOItem code="ANZSCO 313312" title="Telecommunications Field Engineers" img={TwentyEight} />
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default CDRANZSCO;
